<template>
  <div id="Records">
    <div class="top">
      <p class="title">
        奖励记录
      </p>
      
    </div>
    <div class="datecal">
      <p><span>奖品</span><span>抽奖时间</span></p>
      <p v-for="(i,item) in personPrizes" :key="item"><span v-if="i.prize">{{i.prize.name}}</span><span>{{i.created_at}}</span></p>
    </div>
  </div>
</template>

<script>
// 关于我们
export default {
  name: 'Records',
  created(){
    this.Global.getShareConfig({
      title: '每日签到福利',
      desc: '签到抽豪礼，不要错过咯~'
    },this)
  },
  data(){
    return{
      personPrizes:[
        {
          created_at:'',
          prize:{
            name:'',
            id:''
          }
        }
      ]
    }
  },
  methods:{
    getAllList(){
      this.axios({
        method: "POST",
        url: `checkin/person-prizes`,
        data:{
          data:this.data
        },
        headers: {
          Authorization: `Bearer ${this.Global.getCookie("token")}`
        }
      }).then(res => {
        console.log(res.data.data.personPrizes[0].prize,'res====')
        this.personPrizes = res.data.data.personPrizes
      })
    }
  },
  mounted(){
    this.getAllList();
  }
}
</script>

<style scoped>
#Records{
  background: #F9F9F9;
  position: absolute;
  height: 100vh;
  width: 100%;
  overflow: auto;
}
#Records .datecal{
  border-radius: 1rem;
  background: #FFFFFF;
  border-radius: 1rem;
  margin: -3.7rem 1rem 0;
}
#Records .datecal>p{
  height: 2.66rem;
  border-bottom: 1px solid #E9E9E9;
  padding: 0 1.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #868686;
  font-size: 0.75rem;
}
#Records .datecal>p:nth-child(1){
  height: 2.91rem;
  color: #343434;
  font-weight: bold;
  font-size: 0.88rem;
}
/* #Records .datecal>p:nth-child(1)>span:nth-child(1){
  padding-left: 1.16rem;
} */
#Records .datecal>p:last-child{
  border: none;
}

#Records .top .title{
  font-size: 1.13rem;
  color: #fff;
  text-align: center;
  padding-top: 0.8rem;
}
#Records  .top{
  background: url(../assets/images/activity/bj2.jpg) no-repeat ;
  background-size: 100% 100%;
  padding-bottom: 10.7rem;
}



</style>